import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { ThemeProvider} from '@mui/material/styles';
import TabPanel from "./components/partials/TabPanel";
import tabs from "./resources/tabs";
import theme from './utilities/theme';

const App = (_) => {
  const [activeTab, setActiveTab] = useState(0);

  const onTabChange = (e, v) => {
    setActiveTab(v);
  };
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          aria-label="fagron calculators"
        >
          {tabs.map((tabProps, i) => (
            <Tab
              label={tabProps.label}
              id={`tab-${i}`}
              aria-controls={`tab-${i}`}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tabProps, i) => {
        const { Tab } = tabProps;
        return (
          <TabPanel value={activeTab} index={i} key={i}>
            <Tab {...tabProps}/>
          </TabPanel>
        );
      })}
    </ThemeProvider>
  );
};

export default App;
